import React from "react";

export const AnchorLinkIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path
      d="M7.39092 9.80535C7.73643 10.2677 8.17724 10.6503 8.68345 10.9272C9.18966 11.204 9.74944 11.3686 10.3248 11.4099C10.9002 11.4511 11.4777 11.368 12.0181 11.1662C12.5586 10.9644 13.0493 10.6486 13.4572 10.2402L15.8708 7.82419C16.6035 7.06473 17.009 6.04757 16.9998 4.99176C16.9907 3.93596 16.5676 2.926 15.8218 2.17941C15.0759 1.43282 14.067 1.00933 13.0122 1.00015C11.9575 0.99098 10.9414 1.39685 10.1827 2.13036L8.79886 3.50751M10.6091 8.19465C10.2636 7.73227 9.82276 7.34969 9.31655 7.07284C8.81033 6.796 8.25056 6.63137 7.6752 6.59012C7.09984 6.54887 6.52235 6.63197 5.98189 6.83378C5.44143 7.03559 4.95065 7.35139 4.54284 7.75976L2.12922 10.1758C1.39645 10.9353 0.990985 11.9524 1.00015 13.0082C1.00932 14.064 1.43238 15.074 2.17822 15.8206C2.92407 16.5672 3.93301 16.9907 4.98775 16.9998C6.04249 17.009 7.05863 16.6031 7.81732 15.8696L9.19309 14.4925"
      stroke="#474f7b"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
